import pagesIcon from "../assets/pages.svg";
import navIcon from "../assets/nav.svg";
import contactIcon from "../assets/contact.svg";
import blogsIcon from "../assets/blogs.svg";
import fileIcon from "../assets/file-icon.svg";
import libraryIcon from "../assets/media.svg";
import settingIcon from "../assets/setting.svg";
import sectionIcon from "../assets/section.svg";
import userIcon from "../assets/user.svg";

const sideMenuConfig = {
  tec: [
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    // { label: "Location Blogs", path: "/location-blogs", icon: blogsIcon },
    { label: "Case Studies", path: "/case-studies", icon: fileIcon },
    { label: "Media News", path: "/news-list", icon: fileIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
    { label: "Account", path: "/account", icon: userIcon },
  ],

  the: [
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    // { label: "Location Blogs", path: "/location-blogs", icon: blogsIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
    { label: "Account", path: "/account", icon: userIcon },
  ],

  eva: [
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    // { label: "Location Blogs", path: "/location-blogs", icon: blogsIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
    { label: "Account", path: "/account", icon: userIcon },
  ],

  default: [
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    // { label: "Location Blogs", path: "/location-blogs", icon: blogsIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
    { label: "Account", path: "/account", icon: userIcon },
  ],
};

export default sideMenuConfig;
